import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';

import TilePlan from '../TilePlan';
import DocumentsGridTree from '../documents/DocumentsGridTree';
import {
  PlansTableColumnDefs,
  PlansTableWithClientColumnDefs,
  EmployeePlansTableWithClientColumnDefs,
} from '../documents/ColumnDefs';

import PlansFilter from '../PlansFilter';
import Constants from '../../../services/Constants';

export const MyPlans = (props) => {
  const filterByPublishedStatus = () => {
    if (props.hideUnpublished) {
      if (props.plans) {
        return _.map(props.plans, (plan) => {
          if (plan.planAdministratorEmail) {
            return plan;
          }
        });
      }
    }
    return props.plans;
  };

  const filterByEntityType = (filter, data) => {
    const entityTypeFilter = filter[Constants.ENTITY_TYPE];
    if (entityTypeFilter) {
      return data.filter(
        (d) =>
          d &&
          (entityTypeFilter.includes(Constants.ALL) ||
            entityTypeFilter.includes(d[Constants.ENTITY_TYPE]))
      );
    }
    return data;
  };

  const filterByPlan = (filter, data) => {
    const planFilter = filter[Constants.PLAN_NAME];
    if (planFilter) {
      data = data.filter(
        (d) =>
          planFilter.includes(Constants.ALL) ||
          (d &&
            d[Constants.PLAN_NAME]
              .toUpperCase()
              .includes(planFilter[0].toUpperCase()))
      );
    }
    return data;
  };

  const filterByClient = (filter, data) => {
    const clientFilter = filter[Constants.CLIENT_NAME];
    if (clientFilter) {
      data = data.filter(
        (d) =>
          clientFilter.includes(Constants.ALL) ||
          (d &&
            d[Constants.CLIENT_NAME]
              .toUpperCase()
              .includes(clientFilter[0].toUpperCase()))
      );
    }
    return data;
  };

  const applyFilters = () => {
    const filter = props.filterPlansBy[props.filterKey];
    let filteredData = filterByPublishedStatus();

    if (filteredData && filter) {
      filteredData = filterByEntityType(filter, filteredData);
      filteredData = filterByPlan(filter, filteredData);
      filteredData = filterByClient(filter, filteredData);
    }
    return filteredData;
  };

  const renderPlans = (plans) => {
    return _.map(plans, (plan) => {
      return (
        <TilePlan
          key={plan.planId}
          plan={plan}
          isEmployee={true}
          isMyPlans={props.isMyPlans}
        />
      );
    });
  };

  const getColumnDefs = () => {
    if (props.singleClient) {
      return PlansTableColumnDefs;
    } else if (props.isEmployee) {
      return EmployeePlansTableWithClientColumnDefs;
    } else {
      return PlansTableWithClientColumnDefs;
    }
  };

  const renderPlansByClient = () => {
    const clients = _.groupBy(applyFilters(), 'clientName');
    const clientNames = _.keys(clients);
    const ordered = clientNames.sort((a, b) =>
      a.toLowerCase().localeCompare(b.toLowerCase())
    );
    if (props.portfoliosViewModel && props.isMyPlans) {
      return (
        <div className="plansTable">
          <DocumentsGridTree
            rowData={applyFilters()}
            columnDefs={getColumnDefs()}
            isLoading={props.plansRequest.loading}
            hasLoaded={props.plansRequest.isLoaded}
            headerHeight={65}
            groupDefaultExpanded={1}
          />
        </div>
      );
    } else if (props.portfoliosViewModel) {
      return (
        <div className="plansTable">
          <DocumentsGridTree
            rowData={applyFilters() || []}
            columnDefs={getColumnDefs()}
            isLoading={props.plansByLetterRequest.loading}
            hasLoaded={props.plansByLetterRequest.isLoaded}
            noRowsMessage={
              props.letterFilter ? null : 'Select a Letter to filter'
            }
            headerHeight={65}
            groupDefaultExpanded={1}
          />
        </div>
      );
    } else if (ordered.length > 0) {
      return _.map(ordered, (clientName) => {
        if (clientName && clientName !== 'undefined') {
          const plans = clients[clientName];
          return (
            <div key={clientName}>
              <h4>{clientName}</h4>
              <div className="tilesWrapper">{renderPlans(plans)}</div>
            </div>
          );
        }
        return null;
      });
    } else if (
      (props.letterFilter && props.plansByLetterRequest.isLoading) ||
      (props.isMyPlans && props.plansRequest.isLoaded)
    ) {
      return <div className="no-plans-message">{`No Rows to show`}</div>;
    }
  };

  return (
    <div>
      <PlansFilter
        data={applyFilters()}
        documentView={props.filterKey}
        singleClient={props.singleClient}
        isMyplans={props.isMyPlans}
      />
      {renderPlansByClient()}
    </div>
  );
};

MyPlans.propTypes = {
  plans: PropTypes.array,
  plansRequest: PropTypes.object,
  plansByLetterRequest: PropTypes.object,
  hideUnpublished: PropTypes.bool,
  isMyPlans: PropTypes.bool,
  portfoliosViewModel: PropTypes.bool,
  filterKey: PropTypes.string.isRequired,
  filterPlansBy: PropTypes.object,
  singleClient: PropTypes.bool.isRequired,
  isEmployee: PropTypes.bool,
  letterFilter: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    letterFilter: state.ui.letterFilter,
    plansRequest: state.resources.plans,
    plansByLetterRequest: state.resources.all_plans,
    hideUnpublished: state.ui.hideUnpublished,
    portfoliosViewModel: state.ui.portfoliosViewModel,
    filterPlansBy: state.ui.filterBy,
    isEmployee: state.okta.isEmployee,
  };
};

export default connect(mapStateToProps)(MyPlans);
